












































































import Vue from "vue";
import { loginRedirect, takeFailedLogin } from "@/services/msal";
import { loginError } from "@/utilities/login-error";

export default Vue.extend({
  data() {
    return {
      errorMessage: takeFailedLogin(),
      situations: ["microsoft365", "otherProvider", "personalMicrosoft"],
      questions: ["createAccount", "noEmail", "unknownAccount", "blocked"]
    };
  },
  computed: {
    isAuthenticating(): boolean {
      return this.$store.getters["account/isPending"];
    },

    hasAzureLogin(): boolean {
      return !!this.$store.getters["entraClientId"];
    }
  },

  methods: {
    async azureSignIn() {
      this.errorMessage = null;

      try {
        // Navigates away to Microsoft; the return is handled in main.js
        await loginRedirect();
      } catch (e) {
        this.errorMessage = loginError(e);
      }
    }
  }
});
